<template>
  <v-container fluid>
    <!-- <v-row>
      <v-col cols="12">
        <Title />
      </v-col>
    </v-row>
    <News />
    <NewsIncome />-->
    <v-row>
      <v-col cols="12" sm="12">
        <DataTable
          :headers="headers_orders"
          :items="itemsOrders"
          :search="orders_search"
          :pagination="order_shipping_pagination"
          title="Mis Pedidos Pendientes de Facturación"
          @event:change="HandlerEvent"
        />
      </v-col>
      <v-col cols="12" sm="12">
        <DataTable
          :headers="headers_pending_shipping"
          :items="itemsPendingShipping"
          :search="shipping_search"
          :pagination="pending_shipping_pagination"
          title="Mis Pedidos Facturados"
          @event:change="HandlerEventPendingShipping"
        />
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col cols="12" sm="12">
        <DataTable
          :headers="headers_technical_services"
          :items="itemsTechnicalServices"
          :search="technicians_search"
          title="Mis Servicios Técnicos Pendientes"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// import Title from "./Sections/Titles";
// import News from "./Sections/News";
// import NewsIncome from "./Sections/NewsIncome";
import DataTable from "./Utils/DataTable";
export default {
  components: {
    // Title,
    // News,
    // NewsIncome,
    DataTable,
  },
  data() {
    return {
      orders_search: "",
      shipping_search: "",
      technicians_search: "",
      headers_orders: [
        {
          text: "Fecha Emisión",
          value: "created_at",
          class: "length_text pt-auto black--text",
          width: "140",
          align: "end",
        },
        {
          text: "Número Pedido",
          value: "sale_id",
          class: "length_text pt-auto black--text",
          width: "160",
          align: "end",
        },
        {
          text: "Subtotal NETO",
          value: "total_amount",
          class: "length_text pt-auto black--text",
          width: "150",
          align: "end",
        },
        {
          text: "Fecha de Vencimiento",
          value: "due_date",
          class: "length_text pt-auto black--text",
          width: "190",
          align: "end",
        },
        {
          align: "center",
          text: "Acciones",
          value: "actions",
          class: "length_text pt-auto black--text",
        },
      ],
      headers_pending_shipping: [
        {
          text: "Fecha Factura",
          value: "date_created",
          class: "length_text pt-auto black--text",
          width: "140",
          align: "end",
        },
        {
          text: "Número Factura",
          value: "bill_number",
          class: "length_text pt-auto black--text",
          width: "160",
          align: "end",
        },
        {
          text: "Subtotal NETO",
          value: "sale_total",
          class: "length_text pt-auto black--text",
          width: "150",
          align: "end",
        },
        {
          text: "Estatus",
          value: "status",
          class: "length_text pt-auto black--text",
          width: "190",
          align: "end",
        },
        {
          align: "center",
          text: "Acciones",
          value: "buttons_check_in",
          class: "length_text pt-auto black--text",
        },
      ],
      // headers_pending_shipping: [
      //   {
      //     text: "Fecha de Factura",
      //     value: "date_first_printed",
      //     class: "length_text pt-auto black--text",
      //     width: '140',
      //   },
      //   {
      //     text: "Número de Factura",
      //     value: "bill_number",
      //     class: "length_text pt-auto black--text",
      //     width: '140',
      //   },
      //   {
      //     text: "Subtotal NETO",
      //     value: "sale_total",
      //     class: "length_text pt-auto black--text",
      //     width: '140',
      //   },
      //   {
      //     text: "Estatus",
      //     value: "status",
      //     class: "length_text pt-auto black--text",
      //     width: '140',
      //   },
      //   {
      //     align:'center',
      //     text: "Acciones",
      //     value: "buttons_check_in",
      //     class: "length_text pt-auto black--text",
      //     width: '140',
      //   }
      // ],
      headers_technical_services: [
        {
          text: "Fecha",
          value: "date_create_ticket",
          class: "length_text pt-auto black--text",
        },
        {
          text: "Código",
          value: "id",
          class: "length_text pt-auto black--text",
        },
        {
          text: "Descripción",
          value: "description",
          class: "length_text pt-auto black--text",
        },
      ],
    };
  },
  computed: {
    itemsOrders() {
      return this.$store.getters["layout/ORDERS"];
    },
    itemsPendingShipping() {
      return this.$store.getters["layout/PENDING_SHIPPING"];
    },
    itemsTechnicalServices() {
      return this.$store.getters["layout/TECHNICAL_SERVICES"];
    },
    order_shipping_pagination() {
      return this.$store.getters["layout/PAGINATION"];
    },
    pending_shipping_pagination() {
      return this.$store.getters["layout/PAGINATION_PENDING_SHIPPING"];
    },
  },
  created() {
    this.my_orders();
    this.pending_shipping();
    // this.technical_services();
  },
  methods: {
    async my_orders(page = 1) {
      try {
        const request = {
          page: page,
          per_page: 5,
          paginate: true,
        };
        await this.$store.dispatch("layout/MY_ORDERS", request);
      } catch (error) {
        console.log(error);
      }
    },

    async pending_shipping(page = 1) {
      try {
        const request = {
          page: page,
          per_page: 5,
          paginate: true,
        };
        await this.$store.dispatch("layout/PENDING_SHIPPING", request);
      } catch (error) {
        console.log(error);
      }
    },

    async technical_services() {
      try {
        await this.$store.dispatch("layout/TECHNICAL_SERVICES");
      } catch (error) {
        console.log(error);
      }
    },

    HandlerEvent(page) {
      this.my_orders(page);
    },

    HandlerEventPendingShipping(page) {
      console.log('page',page)
      this.pending_shipping(page);
    },
  },
};
</script>

<style></style>
